import React, { useEffect } from "react";
import StudioLayout from "../Layout/StudioLayout";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import Loader from "../Generic/Loader";
import Page from "../Generic/Page";

const StudioRoute = (props) => {
	const auth = props.login;
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if(auth === false) navigate('/login', { state:{ redirectTo: location.pathname } });; 
	}, [auth])

	if (auth === undefined) {
		return (
			<Page>
				<Loader />
			</Page>
		);
	}

	if (auth) {
		return (
			<StudioLayout>
				<Outlet />
			</StudioLayout>
		);
	}
};

export default StudioRoute;
